import { AuditLog } from '../../types/auditLog.ts';
import { AuditLogState } from '../reducers/auditLog.reducer.ts';
import { RootState } from '../store.ts';

const getAuditLogState = (state: RootState): AuditLogState => state.auditLog;

export const getAuditLogs = (state: RootState): AuditLog[] => getAuditLogState(state).auditLogs;
export const getAuditLogsPage = (state: RootState): number => getAuditLogState(state).page;
export const getAuditLogsPageSize = (state: RootState): number => getAuditLogState(state).pageSize;
export const getAuditLogsTotalElements = (state: RootState): number => getAuditLogState(state).totalElements;
export const getIsLoadingAuditLogs = (state: RootState): boolean => getAuditLogState(state).isLoading;
export const getAuditLogsError = (state: RootState): string => getAuditLogState(state).error;
